<template>
    <div class="">
        <div class="row">
            <div class="col-sm-6">
                <vue-switch-with-label @input="toggleEventsSubscription"
                                       v-model="subscribe"
                                       v-show="allowChangeSubscription"
                                       label="Subscribe to Group Calendar"
                                       name="subscribe"></vue-switch-with-label>
                <vue-switch-with-label @input="onArchiveStatusChanged" class="margin-5-top" v-model="archive"
                                       label="Show Archived Events"
                                       name="archive"></vue-switch-with-label>
            </div>
            <div class="col-sm-6 text-right">
                <vue-search-input @search="onSearch" @cancel="onSearchCancel"></vue-search-input>
            </div>
        </div>
        <div class="margin-15-top" v-if="holidays.length">
            <group-events-holiday
                    :holiday="holiday"
                    :editable="isAdmin"
                    @onDelete="onHolidayDelete(holiday)"
                    @onEdit="onHolidayEdit(holiday)"
                    v-for="holiday in holidays"
                    :key="holiday.id"
            ></group-events-holiday>
        </div>
        <div class="margin-15-top">
            <group-events-page-event :event="event" v-for="event in results" :key="event.id"></group-events-page-event>
        </div>
        <div class="margin-15-top" v-if="allLoaded&&results.length===0">
            <div class="alert alert-info">There not any Events matching your criteria in this Group yet</div>
        </div>
        <create-event-popup ref="create-event-popup" v-if="isAdmin"></create-event-popup>
        <group-events-page-add-holiday-popup
                v-if="isAdmin"
                :group-id="group.id"
                ref="group-events-page-add-holiday-popup"></group-events-page-add-holiday-popup>
        <group-events-page-holiday-delete-popup
                v-if="isAdmin"
                ref="group-events-page-holiday-delete-popup"
                :group-id="group.id"
        ></group-events-page-holiday-delete-popup>
        <div v-infinite-scroll="loadMore"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import InfiniteScrollMixin from "../../../../vue/mixins/InfiniteScrollMixin";
    import CreateEventPopup from "../../events/new_event/CreateEventPopup.vue";
    import GroupEventsPageEvent from './GroupEventsPageEvent.vue';
    import GroupEventsPageAddHolidayPopup from './GroupEventsPageAddHolidayPopup.vue';
    import GroupEventsPageHolidayDeletePopup from './GroupEventsPageHolidayDeletePopup.vue';
    import GroupEventsHoliday from './GroupEventsHoliday.vue';
    import {VISUAL_DATE_FORMAT} from "../../events/new_calendar/config";
    import moment from 'moment';

    export default {
        name: "GroupEventsPage",
        mixins: [InfiniteScrollMixin],
        props: {
            group: Object,
        },
        components: {
            CreateEventPopup,
            GroupEventsPageEvent,
            GroupEventsPageAddHolidayPopup,
            GroupEventsPageHolidayDeletePopup,
            GroupEventsHoliday
        },
        data() {
            return {
                archive: false,
                subscribe: true,
                allowChangeSubscription: false,

                holidays: [],
            };
        },
        computed: {
            loadedEventsIdList() {
                return this.results.map(e => e.id);
            },
            isAdmin() {
                const CurrentUser = Vue.getAngularModule('CurrentUser');
                return CurrentUser.is_group_admin(this.group.id);
            }
        },
        methods: {
            appendHolidayButtonIfRequired() {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');

                const $rootScope = Vue.getAngularModule('$rootScope');

                if (this.isAdmin) {
                    GroupEventsHolidaysResource.check_group_repeated_events_existence(this.group.id)
                        .then(resp => {
                            const group_repeated_event_exists = resp.data.actual_repeated_events_exists;
                            if (group_repeated_event_exists) {
                                $rootScope.$broadcast('ADD_BUTTON_TO_GROUP_HEADER', {
                                    key: 'pause_events',
                                    handler: this.createHoliday,
                                    iconClass: 'fa-star-christmas',
                                    text: 'Add Holiday',
                                    top: '1px'
                                });
                            }
                        });
                }

            },
            onHolidayDelete(holiday) {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                GroupEventsHolidaysResource.check_if_syncing_holidays_changes_is_possible(holiday.id, this.group.id)
                    .then(resp => {
                        $rootScope.hide_dimmer();
                        return this.$refs['group-events-page-holiday-delete-popup'].show(holiday, resp.data);
                    }, (err) => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                        return new Promise(() => {
                        });
                    })
                    .then(({groupsToDeleteIdList, all}) => {
                        $rootScope.show_dimmer();
                        let id_list = all ? [] : [this.group.id];
                        if (groupsToDeleteIdList && groupsToDeleteIdList.length) {
                            id_list = id_list.concat(groupsToDeleteIdList);
                        }
                        return GroupEventsHolidaysResource.delete_events_holidays(holiday.id, {id_list, all});
                    }, err => {
                        return new Promise(() => {
                        });
                    })
                    .then(resp => {
                        Vue.notifications.success('Deleted');
                        this.holidays.splice(this.holidays.indexOf(holiday), 1);
                        this.resetResults();
                        this.getResults(true);
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    });
            },
            onHolidayEdit(holiday) {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                GroupEventsHolidaysResource.check_if_syncing_holidays_changes_is_possible(holiday.id, this.group.id)
                    .then(resp => {
                        $rootScope.hide_dimmer();
                        return this.$refs['group-events-page-add-holiday-popup'].edit(holiday, resp.data);
                    }, (err) => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                        return new Promise(() => {
                        });
                    })
                    .then(({startDate, endDate, name, description, syncWithGroupsIdList, groupsToSyncAllSelected}) => {
                        $rootScope.show_dimmer();
                        let idList = groupsToSyncAllSelected ? [] : [this.group.id];
                        if (syncWithGroupsIdList && syncWithGroupsIdList.length) {
                            idList = idList.concat(syncWithGroupsIdList);
                        }
                        return GroupEventsHolidaysResource.update_event_holidays(holiday.id, {
                            start_date: moment(startDate).format(VISUAL_DATE_FORMAT),
                            end_date: moment(endDate).format(VISUAL_DATE_FORMAT),
                            name: name,
                            description: description,
                            id_list: idList,
                            all: groupsToSyncAllSelected,
                        });
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        Vue.notifications.success('Updated');
                        Object.assign(holiday, resp.data);
                        this.resetResults();
                        this.getResults(true);
                    }, err => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                    });
            },
            getEventsHolidays() {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');
                GroupEventsHolidaysResource.get_events_holidays_in_group(this.group.id)
                    .then(resp => {
                        this.holidays = resp.data;
                    });
            },
            createHoliday() {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();

                GroupEventsHolidaysResource.check_if_creating_holidays_in_another_groups_is_possible(this.group.id)
                    .then(resp => {
                        $rootScope.hide_dimmer();
                        return this.$refs['group-events-page-add-holiday-popup'].create(resp.data);
                    }, err => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                        return new Promise(() => {
                        });
                    })
                    .then(({startDate, endDate, name, description, addToGroupsIdList}) => {
                        $rootScope.show_dimmer();
                        let groupsIdList = [this.group.id];
                        if (addToGroupsIdList && addToGroupsIdList.length) {
                            groupsIdList = groupsIdList.concat(addToGroupsIdList);
                        }
                        return GroupEventsHolidaysResource.create_events_holidays_in_groups(groupsIdList, {
                            start_date: moment(startDate).format(VISUAL_DATE_FORMAT),
                            end_date: moment(endDate).format(VISUAL_DATE_FORMAT),
                            name: name,
                            description: description,
                        });
                    }, () => {
                        return new Promise(() => {
                        });
                    })
                    .then(resp => {
                        Vue.notifications.success('Created');
                        this.holidays.unshift(resp.data);
                        this.resetResults();
                        this.getResults(true);
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    });
            },
            getListEndpoint() {
                const GroupResource = Vue.getAngularModule('GroupResource');
                return GroupResource.get_events;
            },
            getListEndpointArgs() {
                return [this.group.id, !this.archive];
            },
            createEvent() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $filter = Vue.getAngularModule('$filter');
                const notifications = Vue.getAngularModule('notifications');
                const CalendarEventsResource = Vue.getAngularModule('CalendarEventsResource');
                this.$refs['create-event-popup'].show({privateEvent: false}, {
                    header: `Create Group Event in ${this.group.name}`,
                    privateLabel: `Make this a Private Event. (Hide from un-invited Group members)`,
                    privateHelpText: null
                })
                    .then(eventData => {
                        // console.log(eventData);
                        $rootScope.show_dimmer();
                        return CalendarEventsResource.create_calendar_event({
                            target: 'group',
                            group_id: this.group.id
                        }, eventData);
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        document.location.href = $filter('backHref')(resp.data.link);
                        notifications.success('Created');
                    }, err => {
                        notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    })
                    .finally();
            },
            getSubscriptionStatus() {
                const GroupEventsSubscriptionResource = Vue.getAngularModule('GroupEventsSubscriptionResource');
                const notifications = Vue.getAngularModule('notifications');
                GroupEventsSubscriptionResource.get_events_subscription_status(this.group.id)
                    .then(resp => {
                        this.subscribe = resp.data.is_subscribed;
                        this.allowChangeSubscription = resp.data.can_manage_subscription;
                    }, err => {
                        notifications.error(err || 'Error');
                    });
            },
            toggleEventsSubscription() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const GroupEventsSubscriptionResource = Vue.getAngularModule('GroupEventsSubscriptionResource');
                const notifications = Vue.getAngularModule('notifications');
                const endPoint = this.subscribe ? GroupEventsSubscriptionResource.subscribe_on_group_events : GroupEventsSubscriptionResource.unsubscribe_from_group_events;
                $rootScope.show_dimmer();
                endPoint(this.group.id, this.loadedEventsIdList).then(resp => {
                    notifications.success('Subscription Updated');
                    this.subscribe = resp.data.subscription;
                    for (let event of this.results) {
                        event.is_member = resp.data.membership_status[event.id];
                    }
                }, err => {
                    notifications.error(err || 'Error');
                })
                    .finally($rootScope.hide_dimmer);
            },
            onArchiveStatusChanged() {
                this.resetResults();
                this.getResults(true);
            }
        },
        mounted() {
            this.getSubscriptionStatus();
            this.appendHolidayButtonIfRequired();
            this.getEventsHolidays();
            const $rootScope = Vue.getAngularModule('$rootScope');
            const CurrentUser = Vue.getAngularModule('CurrentUser');
            if (CurrentUser.is_group_admin(this.group.id)) {
                $rootScope.$broadcast('ADD_BUTTON_TO_GROUP_HEADER', {
                    key: 'create_event',
                    handler: this.createEvent,
                    iconClass: 'fa-plus',
                    text: 'Create Event',
                    top: '1px'
                });
            }


        },
        beforeDestroy() {
            const $rootScope = Vue.getAngularModule('$rootScope');
            $rootScope.$broadcast('REMOVE_BUTTON_FROM_GROUP_HEADER', 'create_event');
            $rootScope.$broadcast('REMOVE_BUTTON_FROM_GROUP_HEADER', 'pause_events');
        }
    };
</script>

<style scoped lang="scss">

</style>